/**
 * Add a CSS class with an animation to an element and remove the class when
 * the animation is finished. Returns a promise resolved with the element when
 * the animation is finished.
 * @template {HTMLElement} T
 * @param {T} element
 * @param {string} className
 * @returns {Promise<T>}
 */
export function animateOnce(element, className) {
  return new Promise((resolve) => {
    element.addEventListener(
      "animationend",
      () => {
        element.classList.remove(className);
        resolve(element);
      },
      { once: true },
    );
    element.classList.add(className);
  });
}
